document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.protect-wrapper');
  if (!wrapper) return;

  const target = document.querySelector('.protect-target');
  const correct = wrapper.dataset.password || '';
  const input = wrapper.querySelector('.protect-input');
  const button = wrapper.querySelector('.protect-submit');
  const error = wrapper.querySelector('.protect-error');

  error.style.display = 'none';
  if (target) target.style.display = 'none'; // 毎回ロック

  button.addEventListener('click', () => {
    if ((input.value || '') === correct) {
      wrapper.style.display = 'none';
      if (target) target.style.display = '';
    } else {
      error.style.display = 'block';
    }
  });
});
